import api from "./index";
import { User, UserCreate, UserUpdate } from "../models/users";
const BASE = '/users';

export const register = async (data: UserCreate) => {
    try {
        const response = await api.post(`${BASE}/register`, data);
        return response.data;
    } catch (error) {
        console.error('Failed to register user:', error);
        throw error;
    }
};

// export const getMe = async () => {
//     try {
//         const response = await api.get(`${BASE}/me`);
//         return response.data as User;
//     } catch (error) {
//         console.error('Failed to get user:', error);
//         throw error;
//     }
// };

export const getRole = async () => {
    try {
        const response = await api.get(`${BASE}/getrole`);
        return response.data;
    } catch (error) {
        console.error('Failed to get role:', error);
        throw error;
    }
};

export const getEmail = async () => {
    try {
        const response = await api.get(`${BASE}/getemail`);
        return response.data;
    } catch (error) {
        console.error('Failed to get email:', error);
        throw error;
    }
};

export const getAllUsers = async () => {
    try {
        const response = await api.get(`${BASE}/getall`);
        return response.data as User[];
    } catch (error) {
        console.error("Failed to get all users:", error);
        throw error;
    }
};

export const deleteUser = async (email: string) => {
    try {
        const response = await api.delete(`${BASE}/delete/${email}`);
        return response.data;
    } catch (error) {
        console.error('Failed to delete user:', error);
        throw error;
    }
};

export const updateUserByEmail = async (updates: UserUpdate): Promise<User> => {
    try {
        const response = await api.patch(`${BASE}/update`, updates);
        return response.data as User;
    } catch (error) {
        console.error("Failed to update user:", error);
        throw error;
    }
};

export const getAllAdminEmails = async () => {
    try {
        const response = await api.get(`${BASE}/getalladminemails`);
        return response.data as string[];
    } catch (error) {
        console.error('Failed to get email:', error);
        throw error;
    }
};

export const getAllEmails = async () => {
    try {
        const response = await api.get(`${BASE}/getallemails`);
        return response.data as string[];
    } catch (error) {
        console.error('Failed to get email:', error);
        throw error;
    }
};
